import { Plus } from '@/icons'

import IconContainer from '../IconContainer'

import { Props } from './typings'
import BaseBtn from './BaseBtn'

export function CustomFieldItem(props: Props) {
  const { children, onClick, disabled } = props

  return (
    <BaseBtn onClick={onClick} disabled={disabled}>
      <IconContainer>
        <Plus />
      </IconContainer>
      {children}
    </BaseBtn>
  )
}
